class EmailNotification {

    constructor() {
        this.subject = '';
        this.subscriptionId = '';
        this.uuid = '';
        this.categories = [];
        this.severities = [];
        this.recipients = '';
    }

    static getSearchKey() {
        return 'subject';
    }

    static fromRaw(raw) {
        let notification = new EmailNotification();
        notification.subject = raw.subject;
        notification.subscriptionId = raw.subscriptionId;
        notification.uuid = raw.uuid;
        notification.categories = raw.categories;
        notification.severities = raw.severities;
        notification.recipients = raw.recipients;
        return notification;
    }

    toRaw() {
        let notification = {};
        notification.subject = this.subject;
        // notification.subscriptionId = this.subscriptionId;
        // notification.id = this.uuid;
        notification.categories = this.categories;
        notification.severities = this.severities;
        notification.recipients = this.recipients;
        notification.uuid = this.uuid;
        return notification;
    }
}

module.exports = EmailNotification;


// WEBPACK FOOTER //
// ./src/azurebackup/model/EmailNotification.js